const useMaximumScreenBrightness = () => {};

export default useMaximumScreenBrightness;
